import React from 'react';
import { Button } from 'antd';

const PhotoInputButton = ({ index, handlePhotoCapture, handlePhotoClick, photos, t, id }) => {
  return (
    <>
      <input
        type='file'
        accept='image/*'
        capture='camera'
        onChange={(event) => handlePhotoCapture(index, event)}
        className='photoCaptureInput'
        data-id={id}
        style={{ display: 'none' }}
      />
      <Button
        size='large'
        style={{
          width: 'fit-content',
          borderColor: 'white',
          background: photos[index] ? '#FF4D4F' : '#1777FF',
          color: 'white',
        }}
        onClick={() => handlePhotoClick(index)}
      >
        {photos[index] ? t('remove_photo') : t('capture_upload_photo')}
      </Button>
    </>
  );
};

export default PhotoInputButton;
